import { Colors } from '@kvika/audur-theme'
import { PrismicRichText, PrismicRichTextProps } from '@prismicio/react'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { useMediaQuery } from 'react-responsive'

import { AudurButton } from '../../components/audurButtons'
import { GridItem, MainGridContainer } from '../../components/grid-container'
import { TwoPathsSlicePrimary } from '../../prismic/prismicTypes'
import { TranslatedStrings } from '../../utils/translations/TranslatedStrings'
import { ColumnClass } from '../../utils/types/Types'
import { Route } from '../../utils/navigation/Routes'

import styles from './mortgageSlices.module.scss'

export const MortgageTwoPathSlice = ({
	first_option_description,
	first_option_subtitle,
	first_option_title,
	main_description,
	main_image,
	second_option_description,
	second_option_subtitle,
	second_option_title,
	two_paths_main_title,
}: TwoPathsSlicePrimary) => {
	const router = useRouter()
	const translations = TranslatedStrings.is.mortgagePage
	const isTabletOrMobile = useMediaQuery({ query: '(max-width: 979px)' })
	return (
		<MainGridContainer
			backgroundColor={Colors.DarkGray}
			style={isTabletOrMobile ? { gridTemplateColumns: '0fr 1fr 0fr' } : { paddingBottom: 4 }}
		>
			<GridItem
				className={ColumnClass.All}
				style={isTabletOrMobile ? { gridColumn: '1 / -1' } : { gridColumn: '2 / -2' }}
			>
				<div className={styles.twoPaths} data-testid='mortgage-two-paths'>
					<div className={styles.twoPathsLeft} data-testid='two-paths-left'>
						<h3 data-testid='two-paths-main-title'>{two_paths_main_title[0].text}</h3>
						<p data-testid='two-paths-main-description'>{main_description[0].text}</p>
						<Image
							className={styles.twoPathsImage}
							src={main_image.url}
							alt={main_image.alt}
							width={main_image.dimensions.width}
							height={main_image.dimensions.height}
							priority
							data-testid='two-paths-main-image'
						/>
					</div>
					<div className={styles.twoPathsRight} data-testid='two-paths-right'>
						<div className={styles.twoPathsOption} data-testid='two-paths-option-first'>
							<div className={styles.iconTitleWrapper}>
								<div className={`${styles.summaryImage} ${styles.greenSummaryImage} `} data-testid='first-option-icon'>
									<Image
										src='/svg/graph_upward.svg'
										width={24}
										alt='SummaryIcon'
										height={24}
										className={styles.summaryIcon}
										priority
									/>
								</div>
								<h3 data-testid='first-option-title'>{first_option_title ?? translations.twoPathsFirstDefaultTitle}</h3>
							</div>

							<p className={styles.twoPathsSubtitle}>
								{first_option_subtitle ?? translations.twoPathsFirstDefaultSubtitle}
							</p>
							<PrismicRichText field={first_option_description as PrismicRichTextProps['field']} />
							<AudurButton
								onClick={() => router.push(Route.MortgageEquity)}
								size='small'
								variant='outlined'
								data-testid='first-option-button'
							>
								{translations.twoPathsFirstDefaultButton}
							</AudurButton>
						</div>
						<div className={styles.twoPathsOption} data-testid='two-paths-option-second'>
							<div className={styles.iconTitleWrapper}>
								<div className={`${styles.summaryImage} ${styles.redSummaryImage}`} data-testid='second-option-icon'>
									<Image
										src='/svg/calculator_interest.svg'
										width={24}
										alt='SummaryIcon'
										height={24}
										className={styles.summaryIcon}
										priority
									/>
								</div>
								<h3 data-testid='second-option-title'>
									{second_option_title ?? translations.twoPathsSecondDefaultTitle}
								</h3>
							</div>
							<p className={styles.twoPathsSubtitle}>
								{second_option_subtitle ?? translations.twoPathsSecondDefaultSubtitle}
							</p>
							<PrismicRichText field={second_option_description as PrismicRichTextProps['field']} />
							<AudurButton
								onClick={() => router.push(Route.MortgageEqualization)}
								size='small'
								variant='outlined'
								data-testid='second-option-button'
							>
								{translations.twoPathsFirstDefaultButton}
							</AudurButton>
						</div>
					</div>
				</div>
			</GridItem>
		</MainGridContainer>
	)
}

export default MortgageTwoPathSlice
